import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import {style} from '../../../components/pdf/fontstyles';
import {AutoText} from '../../../components/pdf/autoText'; 



const styles = StyleSheet.create({
     
          solidLine: {
           
            borderBottomWidth: 1,   // thickness of the line
            borderBottomColor: '#000', // color (black here)
            width: '100%',         // full width of page or container
          },
          
  
          table: {
            
            display: 'table',
            width: '100%',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#000',
          },
          row: {
            flexDirection: 'row',
            borderBottom: '1px solid #000',
          },
          cell: {
            padding: 5,
            borderRight: '1px solid #000',
            verticalAlign: 'middle',
          },
          headerCell: {
            fontWeight: 'bold',
            backgroundColor: '#f2f2f2',
          },
          // Column specific styles (adjust widths for each column)
          Particulars: {
            width: '60%', 
          },
          RatesRs: {
            width: '40%', 
          },


          bulletRow: {
            flexDirection: 'row',
            alignItems: 'flex-start',
            marginBottom: 6, 
          },
          bulletSymbol: {
            width: 10,
            fontSize: 10,
            marginRight: 5, 
          },
          bulletText: {
            flex: 1,
            fontSize: 10,
            textAlign: 'justify',
            lineHeight: 1.5,
          },
          

          leaveSalaryTable: {
            display: 'table',
            width: '100%',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#000',
            marginBottom: 10,
            fontSize: 10, // Consistent with document style
          },
          leaveSalaryRow: {
            flexDirection: 'row',
            borderBottom: '1px solid #000',
          },
          leaveSalaryHeader: {
            fontWeight: 'bold',
            padding: 5,
            textAlign: 'center',
            borderRight: '1px solid #000',
            backgroundColor: '#f5f5f5', // Light gray background for headers
          },
          leaveSalaryCell: {
            padding: 5,
            borderRight: '1px solid #000',
            textAlign: 'left',
          },
        // Sub-column styles
  subColContainer: {
    width: '50%',
    padding: 5,
    justifyContent: 'center', // Vertical center
  },
  subColText: {
    fontSize: 10,
    lineHeight: 1.5,
  },
  subColBorderRight: {
    borderRightWidth: 1,
    borderRightColor: '#000', // Solid black border
    borderStyle: 'solid',
  },
  // Adjust column styles
  leaveCol1: { 
    width: '50%',
    borderRightWidth: 1,
    borderRightColor: '#000',
  },
  leaveSalaryCell: {
    padding: 5,
    borderRight: '1px solid #000',
    textAlign: 'center',
    justifyContent: 'center',
  },
  leaveCol2: { 
    width: '25%',
  },
  leaveCol3: { 
    width: '25%',
    borderRight: 'none', // Remove right border for last column
  },

  deductionCell: {
    padding: 5,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: '#000',
    justifyContent: 'center',
    alignItems: 'center'
  },

});

        
        
const Form6P2S1 = ({ result }) => {
  const GrossSalary = result.basicPay + result.DA + result.HRA + result.CLA + result.TRA + result.splPay;
  const formattedRetirementDate = result?.dateOfRetirement
  ? (() => {
      const [d, m, y] = result.dateOfRetirement.split('/').map(Number);
      const date = new Date(y, m - 1, d);
      return `${date.toLocaleString('en-US', { month: 'short' })} ${date.getFullYear()}`;
    })()
  : 'N/A';
  const professionalTax = result?.dateOfRetirement
  ? (() => {
      const [d, m, y] = result.dateOfRetirement.split('/').map(Number);
      return m === 1 ? 300 : 200; // If the month is February (2), return 300, otherwise 200
    })()
  : 200; // Default to 200 if dateOfRetirement is not available


    const tableData = [
        [`Pay Level`,result.payLevel, 'Dearness allowance', result.DA],
        ['Pay in Pay Level',result.basicPay,'House Rent Allowance', result.HRA],
        ['Notional pay', result.notionalPay, 'C.L.A.', result.CLA],
        ['Special pay', result.splPay, 'Travelling Allowance', result.TRA,],

        ['Other pay','','Gross Salary', GrossSalary],
      ];

  
  return (
    <View size="A4" style={style.page}> 
             <Text style={[style.title, style.ArialBlack]}>LAST PAY CERTIFICATE</Text>

                <View style={styles.solidLine} />

            <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 10 }}>
            
                <Text style={{textAlign: 'right'}}>Letter No.___________ Date___________</Text>
            </View>

            <AutoText style={style.paragraph}>
            1)	Last Pay Certificate of {result.employeeName}  of the  {result.institutionName} proceeding  on {formattedRetirementDate}.
            </AutoText>
            <Text style={style.paragraph}>
            2)	He /She has been paid up to {result.dateOfRetirement} at the following rates.
            </Text>

               {/* Table */}
              <View style={styles.table}>
                    
                     {/* Table Data */}
                     {tableData.map(([srNo, details, value, rates], index) => (
                      <View style={styles.row} key={index}>
                        <Text style={[styles.cell, styles.Particulars]}>{srNo}</Text>
                        <Text style={[styles.cell, styles.RatesRs]}>{details}</Text>
                        <Text style={[styles.cell, styles.Particulars]}>{value}</Text>
                        <Text style={[styles.cell, styles.RatesRs]}>{rates}</Text>

                      </View>
                    ))}
              </View>
            <Text style={style.paragraph}>Deductions: </Text>



        {/* Deductions Table */}
            <View style={{ flexDirection: 'row', marginBottom: 10 }}>
            <View style={[styles.deductionCell, { width: '25%' }]}>
                    <Text>Professional Tax: {professionalTax}</Text>
                </View>
                <View style={[styles.deductionCell, { width: '25%' }]}>
                    <Text>Income Tax Rs.: 0</Text>
                </View>
                <View style={[styles.deductionCell, { width: '25%', borderLeftWidth: 1, borderLeftColor: '#000' }]}>
                    <Text>G.P.F. Rs.: 0</Text>
                </View>
                <View style={[styles.deductionCell, { width: '25%', borderLeftWidth: 1, borderLeftColor: '#000' }]}>
                    <Text>P.L.I. / S.L.I. Rs.: 0</Text>
                </View>
                
            </View>



            <Text style={style.paragraph}>3)His /Her General Provident Fund Account No. {result.pfno}  is maintained by Accountant General _Jt . Director of Higher, {result.region}, {result.city} / education officer, {result.educationOfficer}</Text>

            <Text style={style.paragraph}>
          	4) He / She made over charge of the office of {result.institutionName}  On the after noon of {result.dateOfRetirement}</Text>
            <Text style={style.paragraph}>
            5)	Recoveries are to be made from the pay of the Government servant as detailed on the reverse.
            </Text>
            <Text style={style.paragraph}>
            6)	He / She has been paid leave salary as detailed below.  Deduction have been made as noted on the reverse.
            </Text>

                {/* Leave Salary Table */}
            <View style={[styles.leaveSalaryTable, , { marginBottom: 0 }]}>
            {/* Header Row - Single header for first column */}
            <View style={styles.leaveSalaryRow}>
                <Text style={[styles.leaveSalaryHeader, styles.leaveCol1]}>Period</Text>
                <Text style={[styles.leaveSalaryHeader, styles.leaveCol2]}>Pay Rate</Text>
                <Text style={[styles.leaveSalaryHeader, styles.leaveCol3]}>Amount</Text>
            </View>
            
            {/* Data Rows - With two equal sub-columns in first column */}
            <View style={styles.leaveSalaryRow}>
                <View style={[styles.leaveCol1, {flexDirection: 'row'}]}>
                <View style={[styles.subColContainer, styles.subColBorderRight]}>
                    <Text style={styles.subColText}>From</Text>
                </View>
                <View style={styles.subColContainer}>
                    <Text style={styles.subColText}>to </Text>
                </View>
                </View>
                <Text style={[styles.leaveSalaryCell, styles.leaveCol2]}></Text>
                <Text style={[styles.leaveSalaryCell, styles.leaveCol3]}></Text>
            </View>
            
            <View style={styles.leaveSalaryRow}>
                <View style={[styles.leaveCol1, {flexDirection: 'row'}]}>
                <View style={[styles.subColContainer, styles.subColBorderRight]}>
                    <Text style={styles.subColText}>NIL</Text>
                </View>
                <View style={styles.subColContainer}>
                    <Text style={styles.subColText}>NIL</Text>
                </View>
                </View>
                <Text style={[styles.leaveSalaryCell, styles.leaveCol2]}>NIL</Text>
                <Text style={[styles.leaveSalaryCell, styles.leaveCol3]}>NIL</Text>
            </View>

            </View>


            <Text style={[style.paragraph, { marginTop: 2 }]}>
            6)	He/ She is entitled to draw following up to <Text style={[style.ArialBold, { textDecorationLine: 'underline' }]}>N.A.</Text> as per Accountant General’s authority No. <Text style={[style.ArialBold, { textDecorationLine: 'underline' }]}>N.A.</Text> Date <Text style={[style.ArialBold, { textDecorationLine: 'underline' }]}>N.A.</Text> He/ She is also entitled to joining time as per rules.
            </Text>
            <Text style={style.paragraph}>
            7)	The details of income-tax recovered from him/ her/ up to date from the begining of the current year are noted on the reverse.
            </Text>
            <Text style={style.paragraph}>
            8)	As per Accountant General’s authority No. <Text style={[style.ArialBold, { textDecorationLine: 'underline' }]}>N.A.</Text> Dated <Text style={[style.ArialBold, { textDecorationLine: 'underline' }]}>N.A.</Text> his/ her undermentioned L.I.C Policy / Plolicies is / are financed from General provident Fund.
            </Text>
            
            <Text style={[ style.ArialItalic,{ fontSize: 8 },{marginRight :50}, {textAlign: 'right'}, {marginTop: 50}]}>Head of Office</Text>

        
    </View>

);
};

export default Form6P2S1;